exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".comment[data-v-12616e80]{margin-bottom:10px;background:#f3f3f3}.history[data-v-12616e80]{overflow-x:hidden}.history[data-v-12616e80]::-webkit-scrollbar{width:6px;border-radius:6px!important}.history[data-v-12616e80]::-webkit-scrollbar-thumb{border-radius:6px!important}", ""]);

// exports
